// extracted by mini-css-extract-plugin
export default {"container":"modal_container__1H18M","header":"modal_header__oe722"};